import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Button,
  Link,
  Grid,
  Row,
  Col,
  Panel,
  Hr,
  Margin,
  Table,
  Text,
} from 'shared/components'
import { admin } from 'routes/route.map'

import { TeamsFilters } from './components/filters'
import * as styles from './styles'

const TeamsOverviewComponent = ({ columns, onSearch, loadTeams }) => (
  <Panel>
    <Text as="h1" size={18} bold>
      Teams
    </Text>
    <Margin tb={3}>
      <Hr width="full" />
    </Margin>
    <Margin tb={3}>
      <Grid>
        <Row>
          <Col xs={12} sm={10}>
            <TeamsFilters debounce={250} onSearch={onSearch} />
          </Col>
          <Col xs={12} sm={2}>
            <div css={styles.controlsWrapper}>
              <Link to={admin.teams.add()}>
                <Button plain>
                  <FontAwesomeIcon size="1x" icon="plus-circle" />
                  <Text size={11}>Add team</Text>
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Grid>
    </Margin>
    <Table id="teams-table" sortable columns={columns} loadData={loadTeams} />
  </Panel>
)

TeamsOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadTeams: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
}

export default TeamsOverviewComponent
